/**
 * B3 — the label on every screen of the local synthetic preview.
 *
 * The preview is a clickable build populated only by the demo seeders. Nobody
 * looking at it may mistake it for a release, a customer's data or evidence
 * that a gate has passed, so the words are fixed here rather than supplied by
 * whoever starts it, and shown in both languages. Amber, R-050's advisory
 * warning — not Orange, which means a human must act. It renders only when the
 * preview's dev server sets `VITE_FIDELEN_PREVIEW=1`; no other build sets it.
 */
export const PREVIEW_LABEL = 'DEVELOPMENT / SYNTHETIC DATA — RELEASE GATES OPEN';
const PREVIEW_LABEL_AR = 'بيئة تطوير / بيانات اصطناعية — بوابات الإصدار مفتوحة';

export function PreviewBanner() {
  if (import.meta.env.VITE_FIDELEN_PREVIEW !== '1') return null;

  return (
    <div
      data-preview-banner=""
      className="border-b border-warning-line bg-warning-surface px-4 py-1.5 text-center text-xs font-semibold text-warning-ink"
    >
      <span dir="ltr" lang="en">
        {PREVIEW_LABEL}
      </span>
      <span aria-hidden="true"> · </span>
      <span dir="rtl" lang="ar">
        {PREVIEW_LABEL_AR}
      </span>
    </div>
  );
}
